var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalViolations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#749BC5",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.705 6.605c0 1.382-1.133 2.502-2.53 2.502-1.398 0-2.531-1.12-2.531-2.502 0-1.381 1.133-2.502 2.53-2.502 1.398 0 2.53 1.12 2.53 2.502M19.25 10.304c0 1.382-1.133 2.502-2.53 2.502-1.398 0-2.531-1.12-2.531-2.502 0-1.382 1.133-2.502 2.53-2.502 1.398 0 2.531 1.12 2.531 2.502M16.72 13.857c-.87 0-1.705.342-2.32.95a3.224 3.224 0 0 0-.96 2.293v3.063H20V17.1c0-.86-.346-1.685-.96-2.293a3.299 3.299 0 0 0-2.32-.95zM10.827 9.721 8.68 11.852 4.1 10.298a3.58 3.58 0 0 0-.82-.084 3.3 3.3 0 0 0-2.32.95A3.225 3.225 0 0 0 0 13.458v6.709h6.56v-6.713c0-.04-.01-.078-.011-.118l2.07.703a1.062 1.062 0 0 0 1.09-.251l2.614-2.594a1.038 1.038 0 0 0 .01-1.489 1.062 1.062 0 0 0-1.505.016h-.001zM8.19 3.181 9.67.167l1.139.547-1.48 3.014zM9.812 5.62l3.983-.92.289 1.22-3.983.92z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalViolations);
export default __webpack_public_path__ + "static/media/total-violations.051cb730.svg";
export { ForwardRef as ReactComponent };